export const normalizeEntityBeforeSaving = (organization) => {
  const entity = JSON.parse(JSON.stringify(organization));
  return entity;
};
